import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { getControl } from 'src/app/_helpers/utils';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';
import {
  getValuableObjectInsuranceTypeLabel,
  getValuableObjectTypeLabel,
  ValuableObjectInsuranceType,
  ValuableObjectType,
} from 'src/app/enums/valuable-object.enum';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-valuable-objects-form',
  templateUrl: './valuable-objects-form.component.html',
  styleUrls: ['./valuable-objects-form.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class ValuableObjectsFormComponent
  extends LeadFormBase
  implements OnDestroy
{
  @Input()
  formGroup!: FormGroup;

  hasClaimSubscription!: Subscription;

  hasInsuranceSubscription!: Subscription;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.VALUABLE_OBJECTS,
    object: [null],
    objectDescription: [null],
    insuranceSum: [null],
    insurancesTypes: [null],
    hasInsurance: [null],
    companyInsuranceName: [null],
    policeInsuranceNumber: [null],
    hasSinister: [null],
    sinisterReason: [null],
    hasInsuranceRefused: [null],
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) this.metadataFormGroup.patchValue(this.metadata);
    this.formGroup.addControl('metadata', this.metadataFormGroup);
    this.hasInsuranceSubscription = this.metadataFormGroup.controls[
      'hasInsurance'
    ].valueChanges.subscribe((value) => {
      if (!value) {
        this.metadataFormGroup.controls['companyInsuranceName'].reset();
        this.metadataFormGroup.controls['policeInsuranceNumber'].reset();
      }
    });

    this.hasClaimSubscription = this.metadataFormGroup.controls[
      'hasSinister'
    ].valueChanges.subscribe((value) => {
      if (!value) {
        this.metadataFormGroup.controls['sinisterReason'].reset();
      }
    });
  }

  ngOnDestroy(): void {
    this.hasClaimSubscription.unsubscribe();
    this.hasInsuranceSubscription.unsubscribe();
  }

  objectTypeValues = Object.values(ValuableObjectType);

  getObjectTypeEnum = getValuableObjectTypeLabel;

  objectInsuranceTypeValues = Object.values(ValuableObjectInsuranceType);

  getObjectInsuranceTypeLabel = getValuableObjectInsuranceTypeLabel;

  getControl = getControl;
}
